export const deviceDataAttributeHeadText = "Monitoring Values";

export const deviceDataAttributeHelperText = "These are collection of monitoring values available on the device. A customer can choose to monitor one or more, and adjust threshold values from their account."

export const addAttributeButtontext = "Add Monitoring Value"